import { AIConnection } from "./ai-connection"

export const AI = await AIConnection.connect()
